import {platformAPI} from "../../../api/axiosConfig";
import {Hotline} from "../typedefs";
import {useQuery} from "react-query";

async function fetchHotline(id: string | undefined) {
    if (!id){
        return null
    }
    const res = await platformAPI.get<Hotline>(`api/hotlines/${id}`)

    return res.data

}


export function useGetHotline(id: string | undefined) {

    const {data, isLoading, error, refetch} = useQuery(
        ["hotline", id],
        () => fetchHotline(id),
        {
            enabled: !!id,
            cacheTime: 0,
            refetchOnMount: true,
        }
    );

    return {
        data,
        isLoading,
        error,
        refetch
    }


}